__turbopack_context__.v({
  "component": "style-module-scss-module__g42haa__component",
  "eqao-credit": "style-module-scss-module__g42haa__eqao-credit",
  "filter-by-boundary": "style-module-scss-module__g42haa__filter-by-boundary",
  "footer": "style-module-scss-module__g42haa__footer",
  "no-boundary": "style-module-scss-module__g42haa__no-boundary",
  "rating": "style-module-scss-module__g42haa__rating",
  "rating-range": "style-module-scss-module__g42haa__rating-range",
  "rating-section": "style-module-scss-module__g42haa__rating-section",
  "school-attributes": "style-module-scss-module__g42haa__school-attributes",
  "school-info": "style-module-scss-module__g42haa__school-info",
  "school-name": "style-module-scss-module__g42haa__school-name",
  "top": "style-module-scss-module__g42haa__top",
});
